var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import MDSpinner from 'react-md-spinner';

import emptyChatImage from '../../assets/empty-state.svg';

var MessageList = function (_React$Component) {
  _inherits(MessageList, _React$Component);

  function MessageList() {
    _classCallCheck(this, MessageList);

    return _possibleConstructorReturn(this, (MessageList.__proto__ || Object.getPrototypeOf(MessageList)).apply(this, arguments));
  }

  _createClass(MessageList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isLoading = _props.isLoading,
          messages = _props.messages,
          user = _props.user;


      var chatContent = React.createElement(
        'div',
        { className: 'loading-messages-container' },
        React.createElement(MDSpinner, { size: '100' }),
        React.createElement(
          'span',
          { className: 'loading-text' },
          'Loading Messages'
        )
      );

      if (!isLoading && !messages.length) {
        chatContent = React.createElement(
          'div',
          { className: 'text-center img-fluid empty-chat' },
          React.createElement(
            'div',
            { className: 'empty-chat-holder' },
            React.createElement('img', { src: emptyChatImage, className: 'img-res', alt: 'empty chat' })
          ),
          React.createElement(
            'div',
            null,
            React.createElement(
              'h2',
              null,
              ' No new message? '
            ),
            React.createElement(
              'h6',
              { className: 'empty-chat-sub-title' },
              'Send your first message below.'
            )
          )
        );
      } else if (!isLoading && messages.length) {
        chatContent = messages.map(function (message) {
          if (_this2.props.renderMessage) {
            return _this2.props.renderMessage(message);
          } else {
            var isUser = user.uid === message.sender.uid;
            var renderName = void 0;
            if (isUser) {
              renderName = null;
            } else {
              renderName = React.createElement(
                'div',
                { className: 'sender-name' },
                message.sender.name
              );
            }
            return React.createElement(
              'div',
              {
                key: message.id,
                className: 'chat-bubble-row',
                style: { flexDirection: isUser ? 'row-reverse' : 'row' } },
              React.createElement('img', {
                src: message.sender.avatar,
                alt: 'sender avatar',
                className: 'avatar',
                style: isUser ? { marginLeft: '15px' } : { marginRight: '15px' }
              }),
              React.createElement(
                'div',
                { className: 'chat-bubble ' + (isUser ? 'is-user' : 'is-other') },
                renderName,
                React.createElement(
                  'div',
                  {
                    className: 'message',
                    style: { color: isUser ? '#FFF' : '#2D313F' } },
                  message.text
                )
              )
            );
          }
        });
      }
      return chatContent;
    }
  }]);

  return MessageList;
}(React.Component);

export default MessageList;